module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "ats"
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/06int.htm"
    }
  }, [_c('span', {
    staticClass: "no-style-override-19"
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/Hawkins_B4_Ch01.htm"
    }
  }, [_c('span', {
    staticClass: "no-style-override-20"
  }, [_vm._v("Competency 19:")]), _vm._v(" "), _c('span', {
    staticClass: "no-style-override-19"
  }, [_vm._v("Attracting Top Talent")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/Hawkins_B4_Ch02.htm"
    }
  }, [_c('span', {
    staticClass: "no-style-override-20"
  }, [_vm._v("Competency 20:")]), _vm._v(" "), _c('span', {
    staticClass: "no-style-override-19"
  }, [_vm._v("Knowing the Individual")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/Hawkins_B4_Ch03.htm"
    }
  }, [_c('span', {
    staticClass: "no-style-override-20"
  }, [_vm._v("Competency 21:")]), _vm._v(" "), _c('span', {
    staticClass: "no-style-override-19"
  }, [_vm._v("Coaching")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/Hawkins_B4_Ch04.htm"
    }
  }, [_c('span', {
    staticClass: "no-style-override-20"
  }, [_vm._v("Competency 22:")]), _vm._v(" "), _c('span', {
    staticClass: "no-style-override-19"
  }, [_vm._v("Exhorting and Praising")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/Hawkins_B4_Ch05.htm"
    }
  }, [_c('span', {
    staticClass: "no-style-override-20"
  }, [_vm._v("Competency 23:")]), _vm._v(" "), _c('span', {
    staticClass: "no-style-override-19"
  }, [_vm._v("Enabling Performance")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/Hawkins_B4_Ch06.htm"
    }
  }, [_c('span', {
    staticClass: "no-style-override-20"
  }, [_vm._v("Competency 24:")]), _vm._v(" "), _c('span', {
    staticClass: "no-style-override-19"
  }, [_vm._v("Managing Performance")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/Hawkins_B4_Ch07.htm"
    }
  }, [_c('span', {
    staticClass: "no-style-override-20"
  }, [_vm._v("Competency 25:")]), _vm._v(" "), _c('span', {
    staticClass: "no-style-override-19"
  }, [_vm._v("Imparting Ownership")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/Hawkins_B4_Ch08.htm"
    }
  }, [_c('span', {
    staticClass: "no-style-override-19"
  }, [_vm._v("Appendix:")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/Hawkins_B4_Ch08.htm#app1"
    }
  }, [_c('span', {
    staticClass: "no-style-override-19"
  }, [_vm._v("The SCOPE of Leadership Scorecard for Book 4")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/Hawkins_B4_Ch09.htm"
    }
  }, [_c('span', {
    staticClass: "no-style-override-19"
  }, [_vm._v("About the Author")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/Hawkins_B4_Ch09.htm#books"
    }
  }, [_c('span', {
    staticClass: "no-style-override-19"
  }, [_vm._v("Books by Mike Hawkins")])])]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('span', {
    staticClass: "no-style-override-21"
  }, [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IGURES")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/Hawkins_B4_Ch03.htm#fig4.1"
    }
  }, [_c('span', {
    staticClass: "no-style-override-20"
  }, [_vm._v("Figure 4.1:")]), _vm._v(" "), _c('span', {
    staticClass: "no-style-override-19"
  }, [_vm._v("Coaching Approach Flowchart")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/Hawkins_B4_Ch05.htm#fig4.2"
    }
  }, [_c('span', {
    staticClass: "no-style-override-20"
  }, [_vm._v("Figure 4.2:")]), _vm._v(" "), _c('span', {
    staticClass: "no-style-override-19"
  }, [_vm._v("Skill Versus Will Model")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/Hawkins_B4_Ch07.htm#fig4.3"
    }
  }, [_c('span', {
    staticClass: "no-style-override-20"
  }, [_vm._v("Figure 4.3:")]), _vm._v(" "), _c('span', {
    staticClass: "no-style-override-19"
  }, [_vm._v("Levels of Candor")])])]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('span', {
    staticClass: "no-style-override-21"
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ABLES")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/Hawkins_B4_Ch01.htm#tab4.1"
    }
  }, [_c('span', {
    staticClass: "no-style-override-20"
  }, [_vm._v("Table 4.1:")]), _vm._v(" "), _c('span', {
    staticClass: "no-style-override-19"
  }, [_vm._v("Qualities That Attract Top Performers")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/Hawkins_B4_Ch01.htm#tab4.2"
    }
  }, [_c('span', {
    staticClass: "no-style-override-20"
  }, [_vm._v("Table 4.2:")]), _vm._v(" "), _c('span', {
    staticClass: "no-style-override-19"
  }, [_vm._v("Hiring Profile Attributes")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/Hawkins_B4_Ch01.htm#tab4.3"
    }
  }, [_c('span', {
    staticClass: "no-style-override-20"
  }, [_vm._v("Table 4.3:")]), _vm._v(" "), _c('span', {
    staticClass: "no-style-override-19"
  }, [_vm._v("Interviewing Best Practices")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/Hawkins_B4_Ch01.htm#tab4.4"
    }
  }, [_c('span', {
    staticClass: "no-style-override-20"
  }, [_vm._v("Table 4.4:")]), _vm._v(" "), _c('span', {
    staticClass: "no-style-override-19"
  }, [_vm._v("Elements to Include in a Hiring Interview Guide")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/Hawkins_B4_Ch02.htm#tab4.5"
    }
  }, [_c('span', {
    staticClass: "no-style-override-20"
  }, [_vm._v("Table 4.5:")]), _vm._v(" "), _c('span', {
    staticClass: "no-style-override-19"
  }, [_vm._v("People Characteristics You Should Know")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/Hawkins_B4_Ch03.htm#tab4.6"
    }
  }, [_c('span', {
    staticClass: "no-style-override-20"
  }, [_vm._v("Table 4.6:")]), _vm._v(" "), _c('span', {
    staticClass: "no-style-override-19"
  }, [_vm._v("Characteristics of Competent Coaches")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/Hawkins_B4_Ch03.htm#tab4.7"
    }
  }, [_c('span', {
    staticClass: "no-style-override-20"
  }, [_vm._v("Table 4.7:")]), _vm._v(" "), _c('span', {
    staticClass: "no-style-override-19"
  }, [_vm._v("Benefits Missed When Telling People What to Do")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/Hawkins_B4_Ch03.htm#tab4.8"
    }
  }, [_c('span', {
    staticClass: "no-style-override-20"
  }, [_vm._v("Table 4.8:")]), _vm._v(" "), _c('span', {
    staticClass: "no-style-override-19"
  }, [_vm._v("Thought-Provoking Coaching Questions")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/Hawkins_B4_Ch03.htm#tab4.9"
    }
  }, [_c('span', {
    staticClass: "no-style-override-20"
  }, [_vm._v("Table 4.9:")]), _vm._v(" "), _c('span', {
    staticClass: "no-style-override-19"
  }, [_vm._v("Coaching Best Practices")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/Hawkins_B4_Ch03.htm#tab4.10"
    }
  }, [_c('span', {
    staticClass: "no-style-override-20"
  }, [_vm._v("Table 4.10:")]), _vm._v(" "), _c('span', {
    staticClass: "no-style-override-19"
  }, [_vm._v("Employee Development Activities and Assignments")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/Hawkins_B4_Ch04.htm#tab4.11"
    }
  }, [_c('span', {
    staticClass: "no-style-override-20"
  }, [_vm._v("Table 4.11:")]), _vm._v(" "), _c('span', {
    staticClass: "no-style-override-19"
  }, [_vm._v("Three Levels of Contributions Leaders Should Recognize")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/Hawkins_B4_Ch04.htm#tab4.12"
    }
  }, [_c('span', {
    staticClass: "no-style-override-20"
  }, [_vm._v("Table 4.12:")]), _vm._v(" "), _c('span', {
    staticClass: "no-style-override-19"
  }, [_vm._v("Employee Recognition Best Practices")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/Hawkins_B4_Ch05.htm#tab4.13"
    }
  }, [_c('span', {
    staticClass: "no-style-override-20"
  }, [_vm._v("Table 4.13:")]), _vm._v(" "), _c('span', {
    staticClass: "no-style-override-19"
  }, [_vm._v("Problem-Solving Best Practices")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/Hawkins_B4_Ch05.htm#tab4.14"
    }
  }, [_c('span', {
    staticClass: "no-style-override-20"
  }, [_vm._v("Table 4.14:")]), _vm._v(" "), _c('span', {
    staticClass: "no-style-override-19"
  }, [_vm._v("Performance-Enabling Resource Checklist")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/Hawkins_B4_Ch05.htm#tab4.15"
    }
  }, [_c('span', {
    staticClass: "no-style-override-20"
  }, [_vm._v("Table 4.15:")]), _vm._v(" "), _c('span', {
    staticClass: "no-style-override-19"
  }, [_vm._v("Levels of Enabling Assistance")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/Hawkins_B4_Ch05.htm#tab4.16"
    }
  }, [_c('span', {
    staticClass: "no-style-override-20"
  }, [_vm._v("Table 4.16:")]), _vm._v(" "), _c('span', {
    staticClass: "no-style-override-19"
  }, [_vm._v("Levels of Outsider Assistance")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/Hawkins_B4_Ch06.htm#tab4.17"
    }
  }, [_c('span', {
    staticClass: "no-style-override-20"
  }, [_vm._v("Table 4.17:")]), _vm._v(" "), _c('span', {
    staticClass: "no-style-override-19"
  }, [_vm._v("Measurement and Compensation Plan Elements")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/Hawkins_B4_Ch06.htm#tab4.18"
    }
  }, [_c('span', {
    staticClass: "no-style-override-20"
  }, [_vm._v("Table 4.18:")]), _vm._v(" "), _c('span', {
    staticClass: "no-style-override-19"
  }, [_vm._v("Business and Team Review Meeting Agenda")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/Hawkins_B4_Ch06.htm#tab4.19"
    }
  }, [_c('span', {
    staticClass: "no-style-override-20"
  }, [_vm._v("Table 4.19:")]), _vm._v(" "), _c('span', {
    staticClass: "no-style-override-19"
  }, [_vm._v("Options for Dealing with Poor Performers")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/Hawkins_B4_Ch06.htm#tab4.20"
    }
  }, [_c('span', {
    staticClass: "no-style-override-20"
  }, [_vm._v("Table 4.20:")]), _vm._v(" "), _c('span', {
    staticClass: "no-style-override-19"
  }, [_vm._v("Checklist for Confronting Poor Performers")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/Hawkins_B4_Ch07.htm#tab4.21"
    }
  }, [_c('span', {
    staticClass: "no-style-override-20"
  }, [_vm._v("Table 4.21:")]), _vm._v(" "), _c('span', {
    staticClass: "no-style-override-19"
  }, [_vm._v("Consequences of Performance")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/Hawkins_B4_Ch07.htm#tab4.22"
    }
  }, [_c('span', {
    staticClass: "no-style-override-20"
  }, [_vm._v("Table 4.22:")]), _vm._v(" "), _c('span', {
    staticClass: "no-style-override-19"
  }, [_vm._v("Justifications for Increasing Compensation")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/Hawkins_B4_Ch07.htm#tab4.23"
    }
  }, [_c('span', {
    staticClass: "no-style-override-20"
  }, [_vm._v("Table 4.23:")]), _vm._v(" "), _c('span', {
    staticClass: "no-style-override-19"
  }, [_vm._v("Six Levels of Delegation")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/Hawkins_B4_Ch08.htm#tab4.24"
    }
  }, [_c('span', {
    staticClass: "no-style-override-20"
  }, [_vm._v("Table 4.24:")]), _vm._v(" "), _c('span', {
    staticClass: "no-style-override-19"
  }, [_vm._v("The SCOPE of Leadership Scorecard for Book 4")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b5b3db96","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/05-toc.vue
// module id = 72
// module chunks = 0